export const FETCH_APPOINTMENT_DETAILS_REQUEST = "FETCH_APPOINTMENT_DETAILS_REQUEST";
export const FETCH_APPOINTMENT_DETAILS_SUCCESS = "FETCH_APPOINTMENT_DETAILS_SUCCESS";
export const FETCH_APPOINTMENT_DETAILS_FAILURE = "FETCH_APPOINTMENT_DETAILS_FAILURE";
